import type { PlanPackItem } from '../schemas/plan.js'

export interface PackGroup {
  name: string | null
  items: PlanPackItem[]
}

/**
 * Partition pack items by their `group` field.
 * Named groups appear in insertion order (order of first item with that group).
 * Ungrouped items (group === undefined) appear last.
 */
export function groupPackItems(items: PlanPackItem[]): PackGroup[] {
  const groups = new Map<string | null, PlanPackItem[]>()
  for (const item of items) {
    const key = item.group ?? null
    const list = groups.get(key)
    if (list) {
      list.push(item)
    } else {
      groups.set(key, [item])
    }
  }

  const result: PackGroup[] = []
  for (const [name, groupItems] of groups) {
    if (name !== null) result.push({ name, items: groupItems })
  }
  const ungrouped = groups.get(null)
  if (ungrouped) result.push({ name: null, items: ungrouped })
  return result
}
